/**
 * An object representing a Project
 * @typedef {Object} Project
 */

import { ProjectModel } from '@/pigeonline/wrapper';
import PigeonDocNodeModel from './PigeonDocNodeModel';

export default class PigeonDocProject extends ProjectModel {
  constructor(data = {}) {
    super(data);

    this.name = null;
    this.nodes = [];
    this.pdfConfig = null;
    this.schemaVersion = null;

    //initialize props
    this.setProps(data);
  }

  setProps(data) {
    ProjectModel.prototype.setProps.call(this, data);

    if ('nodes' in this) {
      this.nodes = this.nodes.map((node) => new PigeonDocNodeModel(node));
    }
  }

  insertNodeAtIndex(node, index) {
    this.nodes.splice(index, 0, node);
  }

  findIndexForNode(node) {
    return this.nodes.findIndex((el) => JSON.stringify(el) == JSON.stringify(node));
  }

  findSections() {
    function findSections(nodes) {
      const sections = [];
      sections.push(...nodes.filter((el) => el.type === 'section'));

      sections.forEach((el) => {
        if (el.type === 'section') {
          sections.push(...findSections(el.content));
        }
      });
      return sections;
    }

    return findSections(this.nodes);
  }

  insertIntoSection({ insert, before = null, after = null }) {
    const sections = this.findSections();

    sections.forEach((section) => {
      const idx = section.content.findIndex((el) => el.uuid == (before || after).uuid);
      if (idx != -1) {
        section.content.splice(before ? idx : idx + 1, 0, insert);
        return true;
      }
    });
  }

  insertBefore({ insert, before }) {
    const idx = this.nodes.findIndex((el) => el.uuid == before.uuid);

    if (idx != -1) {
      this.insertNodeAtIndex(insert, idx);
      return true;
    } else if (this.insertIntoSection({ insert, before })) {
      return true;
    } else {
      return false;
    }
  }

  insertAfter({ insert, after }) {
    const idx = this.nodes.findIndex((el) => el.uuid == after.uuid);

    if (idx != -1) {
      this.insertNodeAtIndex(insert, idx + 1);
      return true;
    } else if (this.insertIntoSection({ insert, after })) {
      return true;
    } else {
      return false;
    }
  }

  removeNode(node) {
    const idx = this.nodes.findIndex((el) => el.uuid == node.uuid);

    if (idx != -1) {
      this.nodes.splice(idx, 1);
      return true;
    }

    const sections = this.findSections();

    sections.forEach((section) => {
      const idx = section.content.findIndex((el) => el.uuid == node.uuid);
      if (idx != -1) {
        section.content.splice(idx, 1);
      }
    });
  }

  replaceNodeAtIndex(node, index) {
    this.nodes.splice(index, 1, node);
  }

  /**
   * Return config that does not need special formatting or handling
   */
  getPDFConfig() {
    let { images, footer, styles, ...config } = this.pdfConfig; // eslint-disable-line
    return config;
  }

  static PROJECT_TYPE() {
    return 'pigeondoc';
  }
}
